var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.772054 10.8402L11.5706 0.58127C12.2575 -0.0716591 13.3712 -0.0716591 14.0578 0.58127C14.7444 1.23362 14.7444 2.29167 14.0578 2.94396L4.50276 12.0215L14.0575 21.0988C14.7441 21.7514 14.7441 22.8094 14.0575 23.4617C13.3709 24.1143 12.2572 24.1143 11.5703 23.4617L0.771775 13.2026C0.428457 12.8763 0.256991 12.4491 0.256991 12.0216C0.256991 11.5939 0.42879 11.1664 0.772054 10.8402Z",
    fill: "#003A9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftScroll);
export default __webpack_public_path__ + "static/media/left-scroll.cfb7f6ac1fd1ec40264d6957fa0d3073.svg";
export { ForwardRef as ReactComponent };